module.exports = __webpack_public_path__ + "static/hero-top-3-c08814479293aee21241f4334b62fa69.png";